export class PageConfig {
	public defaults: any = {
		'test': {
			menu: { // <= add page URL
				page: { title: 'PAGE.MENU', desc: 'PAGE.MENU.DESC' } // <= Page name and description
			},
			users: { // <= add page URL
				page: { title: 'PAGE.USERS', desc: 'PAGE.USERS.DESC' } // <= Page name and description
			}
		},
		'app': {
			dashboard: {
				page: {
					title: 'PAGE.DASHBOARD',
					desc: 'PAGE.DASHBOARD.DESC'
				},
			},
			stock: {
				list: {
					page: {
						title: 'PAGE.STOCK',
						desc: 'PAGE.STOCK.DESC'
					}
				},
			},
			order: {
				list: {
					page: {
						title: 'PAGE.ORDER',
						desc: 'PAGE.ORDER.DESC'
					}
				}
			},
			report: {
				items: {
					page: {
						title: 'PAGE.REPORT',
						desc: 'PAGE.REPORT.DESC'
					},
					
				},
				metabase: {
					page : {
						title: 'Arac Durumları',
						desc: 'Sirketinizdeki araçlarla ilgili bilgiler...'
					}
				},
				
			},
			admin: {
				// users: {
				// 	page: {
				// 		title: 'PAGE.ADMIN.USERS',
				// 		desc: 'PAGE.USERS.DESC'
				// 	}
					
				// },
				useradd: {
					page: {
						title: 'PAGE.ADMIN.USERS.ADD',
						desc: 'PAGE.ADMIN.USERS.ADD.DESC'
					},	
				},
				useredit: {
					page: {
						title: 'PAGE.ADMIN.USERS.EDIT',
						desc: 'PAGE.ADMIN.USERS.ADD.DESC'
					},	
				},
				// customers: {
				// 	page: {
				// 		title: 'PAGE.ADMIN.CUSTOMERS',
				// 		desc: 'PAGE.ADMIN.CUSTOMERS.DESC'
				// 	},
				// },
				// pages: {
				// 	page: {
				// 		title: 'PAGE.ADMIN.PAGES',
				// 		desc: 'PAGE.ADMIN.PAGES.DESC'
				// 	},
				// },
				// warehouses: {
				// 	page: {
				// 		title: 'PAGE.ADMIN.WAREHOUSES',
				// 		desc: 'PAGE.ADMIN.WAREHOUSES.DESC'
				// 	},
				// },
				// titles: {
				// 	page: {
				// 		title: 'PAGE.ADMIN.TITLES',
				// 		desc: 'PAGE.ADMIN.TITLES.DESC'
				// 	},
				// }
			},
	
			error: {
				404: {
					page: { title: '404 Not Found', desc: '', subheader: false }
				},
				403: {
					page: { title: '403 Access Forbidden', desc: '', subheader: false }
				}
			}

		}
	};

	public get configs(): any {
		return this.defaults;
	}
}
